import SecondaryButton from 'components/buttons/v4/SecondaryButton';
import { useAuthoringContext } from 'pages/authoring/AuthoringContext';
import { useCallback } from 'react';
import { getPreviewSetUrl } from 'utils/pathUtils';

export default function PreviewButton() {
  const { setId, rawItem } = useAuthoringContext();

  const handleStartPreview = useCallback(() => {
    if (!setId) {
      console.error('No set ID available for preview');
      return;
    }

    const firstFacetGuid = rawItem?.facets?.[0]?.guid;
    const previewUrl = getPreviewSetUrl(4, setId, firstFacetGuid);
    window.location.href = previewUrl;
  }, [setId, rawItem]);

  return <SecondaryButton click={handleStartPreview}>Start Preview</SecondaryButton>;
}
